import styled from 'styled-components'

export default styled.button`
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 1rem;
  outline: none;
`



// WEBPACK FOOTER //
// ./src/components/IconButton/index.js